import * as types from "./types";

const initialState = {
  facilitiesData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_FACILITIES_DATA: {
      return {
        ...state,
        facilitiesData: action?.payload?.data,
      };
    }
    default:
      return state;
  }
};

export default reducer;
